// extracted by mini-css-extract-plugin
export var dataCell = "_pf-2";
export var dataRow = "_pf-0";
export var headerRow = "_pf-1";